import { t } from '@/i18n';
import type { FlowId } from '@/lib/flows';
import type { Kind } from './createBridge';

export const KINDS: readonly { readonly id: Kind; readonly title: string; readonly text: string; readonly more?: string }[] = [
  {
    id: 'password',
    get title() { return t('homeKinds.passwordTitle'); },
    get text() { return t('homeKinds.passwordText'); },
    get more() { return t('homeKinds.passwordMore'); },
  },
  {
    id: 'chat',
    get title() { return t('homeKinds.chatTitle'); },
    get text() { return t('homeKinds.chatText'); },
  },
  {
    id: 'receive',
    get title() { return t('homeKinds.receiveTitle'); },
    get text() { return t('homeKinds.receiveText'); },
  },
];

export const TITLES: Record<Kind, string> = {
  get password() { return t('homeKinds.titlePassword'); },
  get chat() { return t('homeKinds.titleChat'); },
  get receive() { return t('homeKinds.titleReceive'); },
};

export function kindOf(value: string | null): Kind | null {
  if (value === 'password' || value === 'file') return 'password';
  return value === 'chat' || value === 'receive' ? value : null;
}

export function flowOf(kind: Kind | null): FlowId {
  if (kind === null) return 'overview';
  return kind === 'password' ? 'secret' : kind;
}

/** The kind of file in a word: its extension in capitals, when it has a short one. */
export function fileKind(name: string): string {
  const dot = name.lastIndexOf('.');
  const ext = dot > 0 ? name.slice(dot + 1) : '';
  return ext.length > 0 && ext.length <= 5 ? ext.toUpperCase() : '';
}
